import SectionTitle from "components/section-title/SectionTitle";

const HobbiesSection: React.FC = () => {
  return (
    <div>
      <SectionTitle>Hobbies</SectionTitle>

      <p>
        My trusted Kindle never too far, reading is for me a daily ritual to
        unwind. I mostly read fantasy books (last in date: the Faithful and the
        Fallen series) and biographies (last in date: Shoe Dog: A Memoir by the
        Creator of Nike).
        <br />
        <br />
        I have been swimming for the better part of my life. It’s my go-to to
        let off some steam (by a small margin ahead of a drink with friends).
        <br />
        <br />I started learning and playing poker because it’s more complex
        than meets the eye. I love the math behind every decision. I believe
        that the self-discipline required in poker to assess every spot and take
        the most viable decision builds skills that transpire in my everyday
        life.
      </p>
    </div>
  );
};

export default HobbiesSection;
